import React from 'react';

const SwitchButton = ({ firstHandler, firstName, secondHandler, secondName, selectedType, type1, type2 }) => {
  return (
    <div>
      <div className='flex bg-richblack-800 p-1 gap-x-1 my-6 rounded-full max-w-max' style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}>
        <button
          onClick={firstHandler}
          className={`${selectedType === type1 ? 'bg-richblack-900 text-richblack-5' : 'bg-transparent text-richblack-200'} py-2 px-5 rounded-full transition-all duration-200`}
        >
          {firstName}
        </button>
        <button
          onClick={secondHandler}
          className={`${selectedType === type2 ? 'bg-richblack-900 text-richblack-5' : 'bg-transparent text-richblack-200'} py-2 px-5 rounded-full transition-all duration-200`}
        >
          {secondName}
        </button>
      </div>
    </div>
  );
};

export default SwitchButton;